import { Button, Grid, TextField,InputAdornment } from '@mui/material';
import { useFormik } from 'formik';
import {React, useEffect, useState} from 'react'
import * as yup from 'yup';
import TimezoneSelect from 'react-timezone-select'

// Channel: non-negative integer, default 0. Off-timer: positive integer, default 10.
// Blank / invalid / negative normalise to those defaults so neither goes negative.
function clampChannel(v) {
    const n = Number(v);
    if (v === '' || v === null || v === undefined || Number.isNaN(n) || n < 0) return 0;
    return Math.floor(n);
}
function clampOffTimer(v) {
    const n = Number(v);
    if (v === '' || v === null || v === undefined || Number.isNaN(n) || n < 1) return 10;
    return Math.floor(n);
}

export default function ShellyLockForm(props)
{
    
    const[isAddOperation,setIsAddOperation] = useState(false);
    const[recvValues,setRecvValues] = useState({ 
        id:null,
        server_uri:'',
        auth_key:'',
        channel:'',
        location_id:props.LocationRow.id,
        off_timer:''
    });

    useEffect(()=>{
        
       if(props.selectedRow !== null )//&& valueLoaded === false)
       {
            
            setRecvValues({
                id:props.selectedRow.id,
                server_uri:props.selectedRow.server_uri,
                auth_key:props.selectedRow.auth_key,
                channel:props.selectedRow.channel,
                location_id:props.selectedRow.location_id,
                off_timer:props.selectedRow.off_timer
            });
            
            setIsAddOperation(false);
        }
        else
        {
            setRecvValues({ 
                id:null, 
                server_uri:'',
                auth_key:'',
                channel:'',
                location_id:props.LocationRow.id,
                off_timer:''
            });
            setIsAddOperation(true);
            
        }

    },[props.selectedRow]);
    
    const validationSchema = yup.object({
        id:yup
        .string()
        .max(25, 'Shelly Id must be at most 25 characters')
        .required("Please enter registered Shelly Id"),
        server_uri: yup
            .string("AAA")
            .matches(
                /((https?):\/\/)?(www.)?[a-z0-9]+(\.[a-z]{2,}){1,3}(#?\/?[a-zA-Z0-9#]+)*\/?(\?[a-zA-Z0-9-_]+=[a-zA-Z0-9-%]+&?)?$/,
                'Enter correct uri! It should start with https '
            )
          .required('Cloud server URI is required'),
          auth_key: yup
          .string("AAA")
        .required('auth_key is required'),
        channel: yup
        .number()
        .typeError('Channel must be a number (0 or greater)')
        .min(0, 'Channel must be 0 or greater')
        .required('Channel is required'),
        off_timer: yup
        .number()
        .typeError('Off-timer must be a number greater than 0')
        .positive('Off-timer must be greater than 0')
        .required('Off-timer is required'),
      });
      function onCancelForm()
      {
          //alert("Cancel");
          props.handleSubmit(null,isAddOperation,true)
      }
   
    
    const formik = useFormik({
        enableReinitialize:true,
        validateOnMount:true,
        validationSchema: validationSchema,
        initialValues:{
            id:recvValues?.id || null,
            server_uri:recvValues?.server_uri || '',
            auth_key:recvValues?.auth_key || '',
            channel:clampChannel(recvValues?.channel),
            location_id:recvValues?.location_id || '',
            off_timer:clampOffTimer(recvValues?.off_timer)

        },

        onSubmit:(values)=>{
        
           // if(values.mac_id === '')
            //    props.handleSubmit(null,isAddOperation,true);
           // else
            //{

                props.handleSubmit(values,isAddOperation,false);
            //}
           //this.resetForm();

        },
        // onReset:(values)=>{
        //     alert("Onreset");

        //     props.handleSubmit(null,isAddOperation,true)
        // }
    });

    // Number fields: clamp negatives to 0 while typing; coerce to their default on blur.
    const handleNumberChange = (field) => (e) => {
        const raw = e.target.value;
        if (raw === '') { formik.setFieldValue(field, '', true); return; }
        let n = Number(raw);
        if (Number.isNaN(n)) return;
        if (n < 0) n = 0;
        formik.setFieldValue(field, Math.floor(n), true);
    };
    const handleChannelBlur = (e) => {
        formik.setFieldValue('channel', clampChannel(formik.values.channel), true);
        formik.handleBlur(e);
    };
    const handleOffTimerBlur = (e) => {
        formik.setFieldValue('off_timer', clampOffTimer(formik.values.off_timer), true);
        formik.handleBlur(e);
    };

    return(
        // <Grid style={{ borderStyle: 'solid', borderColor: 'pink' }} container item spacing={3} xs={12}
        // direction="column" alignItems='flex-start' >
            // <Paper >
            <form onSubmit={formik.handleSubmit} >
                {/* <Grid container spacing={2}> */}
                    <Grid item container xs={12} spacing={2}
                    justifyContent="flex-start" style={{ borderStyle: 'none', borderColor: 'black' }}
                    alignItems='flex-start' direction="row">
                {/* <Grid container spacing={{xs:2,md:5}} direction="row" columns={{xs:4,sm:8,md:12}}> */}
                            <Grid item xs={12} sm={12} md={12}  >
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    required
                                    variant='outlined'
                                    id="id"
                                    name="id"
                                    label="Shelly Id"
                                    value={formik.values.id || ''}
                                    onChange={formik.handleChange}
                                    inputProps={{ maxLength: 25 }}
                                    error={formik.touched.id && Boolean(formik.errors.id)}
                                    helperText={formik.touched.id && formik.errors.id}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    required
                                    variant='outlined'
                                    id="server_uri"
                                    name="server_uri"
                                    label="Cloud Server URI"
                                    value={formik.values.server_uri}
                                    onChange={formik.handleChange}
                                    // InputProps={{
                                    //     startAdornment: <InputAdornment position="start">https</InputAdornment>,
                                    //   }}
                                    error={formik.touched.server_uri && Boolean(formik.errors.server_uri)}
                                    helperText={formik.touched.server_uri && formik.errors.server_uri}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    required
                                    variant='outlined'
                                    id="auth_key"
                                    name="auth_key"
                                    label="Auth Key"
                                    value={formik.values.auth_key}
                                    onChange={formik.handleChange}
                                    error={formik.touched.auth_key && Boolean(formik.errors.auth_key)}
                                    helperText={formik.touched.auth_key && formik.errors.auth_key}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="channel"
                                    name="channel"
                                    label="Channel"
                                    type="number"
                                    required
                                    inputProps={{ min: 0, step: 1 }}
                                    value={formik.values.channel}
                                    onChange={handleNumberChange('channel')}
                                    onBlur={handleChannelBlur}
                                    error={formik.touched.channel && Boolean(formik.errors.channel)}
                                    helperText={formik.touched.channel && formik.errors.channel}
                                />
                            </Grid>
                            <Grid item  xs={12} sm={4} md={5}  >
                                <TextField
                                    fullWidth
                                    variant='outlined'
                                    id="off_timer"
                                    name="off_timer"
                                    label="Off-Timer (in Sec)"
                                    type="number"
                                    required
                                    inputProps={{ min: 0, step: 1 }}
                                    value={formik.values.off_timer}
                                    onChange={handleNumberChange('off_timer')}
                                    onBlur={handleOffTimerBlur}
                                    error={formik.touched.off_timer && Boolean(formik.errors.off_timer)}
                                    helperText={formik.touched.off_timer && formik.errors.off_timer}
                                />
                            </Grid>
                            
                    </Grid>
                    <Grid container item xs={12}
                     direction="row" spacing={3}
                      style={{ borderStyle: 'none', borderColor: 'black' }} justifyContent='flex-start'>
                        <Grid item >
                            <Button type='submit' color='primary' variant='contained' disabled={!formik.isValid}>Submit</Button>
                        </Grid>
                        <Grid item>
                            <Button type='button' onClick={onCancelForm}  color='secondary' variant='contained'>Cancel</Button>
                        </Grid>
                    </Grid>
                {/* </Grid> */}
            </form>
            // </Paper>
        // </Grid>


    );
}